// extracted by mini-css-extract-plugin
module.exports = {"row":"EnrollClinic_row__-DZ_r"};